import { createContext } from 'react';

export interface IGlobalAppContext {
    meta: {
        clientFeatures: {
            useHeader: boolean;
            useFooter: boolean;
        };
    };
}

export const globalAppContext = createContext<IGlobalAppContext>({
    meta: {
        clientFeatures: {
            useHeader: true,
            useFooter: true,
        },
    },
});
